import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const FeaturesAnalyze: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="py-5">
      <Container className="py-5">
        <h2 className="main-header text-center pt-5 pb-3 ">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.analyze.title',
            defaultMessage: 'Analyze'
          })}
        </h2>
        <p className="main-header-subtitle text-center">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.analyze.drive-streams.title',
            defaultMessage: 'Get crucial fans insights and understand your fans on a deeper level.'
          })}
        </p>
        <Row className="py-5">
          <Col xs={12} className="text-center">
            <img
              src={nextAsset('images/smartLinks/features/analyze.jpg')}
              className="img-fluid"
              alt="Analyze - example"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
